import createLucideIcon from '../createLucideIcon';

const Music2 = createLucideIcon('Music2Icon', [
  ['circle', { cx: '8', cy: '18', r: '4', key: '1fc0mg' }],
  ['path', { d: 'M12 18V2l7 4', key: 'g04rme' }],
]);

export default Music2;
